<div class="container" #form>
  <div class="row header">
    <div mat-dialog-title class="col-md-11">
      {{ getEmployeeDialogTitleKey((employee$ | async)) | translate }}
    </div>
    <div class="col-md-1 icon" (click)="close()">
      <asp-icon name="ic-20-utility-close-default.svg"></asp-icon>
    </div>
  </div>
  <div class="row employee-details">
    <form class="employee-form" [formGroup]="employeeForm">
      <div class="row employee">
        <div *ngIf="(employee$ | async)?.jobCode === 'ADVISOR'">
          <div class="row employee-avatar">
            <!-- Upload image -->
            <div class="avatar-upload">
              <div class="avatar-edit">
                <input type='file' id="imageUpload" accept=".png, .jpg, .jpeg" #fileInput
                  (change)="uploadFile($event)" />
              </div>
              <div class="avatar-preview" (click)="fileInput.click()" style="cursor: pointer;">
                <div class="avatar-initials" *ngIf="!f.avatar.value">{{nameInitials}}</div>
                <div *ngIf="f.avatar.value" id="imagePreview" [style.backgroundImage]="'url('+ imageUrl +')'">
                </div>
                <div *ngIf="!f.avatar.value" class="avatar-upload-button" (click)="fileInput.click()">
                  <span>{{'servicePersonnel.upload'| translate}}</span>
                </div>
                <div *ngIf="f.avatar.value" class="avatar-delete" (click)="deleteAvatar($event)">
                  <span>{{'servicePersonnel.delete'| translate}}</span>
                </div>
              </div>
              <div class="pt-3">
                <button class="asp-btn-primary avatar-upload-button" type="button"
                  (click)="fileInput.click()">{{'servicePersonnel.uploadImage'| translate}}</button>
              </div>
            </div>
          </div>
        </div>
        <div class="text" [ngClass]="(employee$ | async)?.jobCode === 'ADVISOR' ? 'col-md-10' : 'col-md-12'">
          <div class="row">
            <div class="col-md-4">
              <span class="text-label">{{'servicePersonnel.name'| translate}} </span>
            </div>
            <div class="col-md-2" style="padding-left:1px">
              <span class="text-label">{{'otherTexts.dmsId'| translate}}</span>
            </div>
            <div class="col-md-2" *ngIf="txmFlag && employee.department==='SERVICE'">
              <span class="text-label">TXM</span>
            </div>
            <div class="col-md-2" *ngIf="employee.department==='SERVICE' && (employee$ | async)?.jobCode === 'ADVISOR'">
              <span class="text-label">{{'serviceSchedule.learning'| translate}}</span>
            </div>
            <div class="col-md-3" [ngStyle]='{"padding-left": isEnglishText ? "0px" : ""}' *ngIf="employee.department==='SALES'">
              <span class="text-label">{{'otherTexts.remoteSalesappt'| translate}}</span>
            </div>
            <div class="col-md-2" [ngStyle]='{"padding-left": isEnglishText ? "" : "25px"}' *ngIf="employee.department !== 'PARTS'">
              <span class="text-label">{{'servicePersonnel.online'| translate}} </span>
            </div>

          </div>
          <div class="row" style="margin-top:10px">
            <div class="col-md-4">
              <span class="text-content">{{(employee$ | async)?.firstName}} {{(employee$ | async)?.lastName}} </span>
            </div>
            <div class="col-md-2" style="padding-left:1px">
              <span class="text-content">{{(employee$ | async)?.externalId}}</span>
            </div>
            <div class="col-md-2" style="padding:0px 7px;" *ngIf="txmFlag && employee.department==='SERVICE'">
              <app-onofswitch [switchInput]='employeeForm.value.isTxm'
                (switchChange)="updateSwitchValues($event, 'isTxm')"></app-onofswitch>
            </div>
            <div class="col-md-2" *ngIf="employee.department==='SERVICE' && (employee$ | async)?.jobCode === 'ADVISOR'">
              <app-onofswitch [switchInput]='employeeForm.value.learning'
                (switchChange)="updateSwitchValues($event, 'learning')"></app-onofswitch>
            </div>
            <div class="col-md-3" *ngIf="employee.department==='SALES'">
              <app-onofswitch [switchInput]='employeeForm.value.remoteConsultant'
                (switchChange)="updateSwitchValues($event, 'remoteConsultant')"></app-onofswitch>
            </div>
            <div class="col-md-2" [ngStyle]='{"padding-left": isEnglishText ? "" : "25px"}' *ngIf="employee.department !== 'PARTS'">
              <app-onofswitch [switchInput]='employeeForm.value.isActive'
                (switchChange)="updateSwitchValues($event, 'isActive')"></app-onofswitch>
            </div>
          </div>

        </div>
        <div class="col-md-8" *ngIf="(employee$ | async)?.jobCode === 'ADVISOR' && employee.department !== 'PARTS'"
          style="margin-left:16%; margin-top: -45px">
          <div class="row profile-visibility">

            <div class="col-md-1 checkbox" style="text-align: right;">
              <mat-checkbox #visibleCheckbox disableRipple formControlName='visibility'>
              </mat-checkbox>
            </div>
            <div class="col-md-6 profileVisibleText"><span>
                {{'servicePersonnel.makeYourProfileVisible'| translate}}</span> </div>
          </div>
        </div>
      </div>

      <div *ngIf="employee.department === 'SALES'">
        <div class="row" style="margin-top: 20px;">
          <div class="col-md-4" [ngStyle]='{"padding-left": isEnglishText ? "4.5rem" : "4rem"}'>
            <span class="text-label">{{'otherTexts.salesDepartment'| translate}}</span>
          </div>
          <div class="col-md-4" [ngStyle]='{"padding-left": isEnglishText ? "6rem" : "8rem"}'>
            <span class="text-label">{{'pendingAppointments.appointmentType'| translate}}</span>
          </div>
          <div class="col-md-4" style="padding-left: 5rem;">
            <span class="text-label">{{'otherTexts.financeDepartment'| translate}}</span>
          </div>
        </div>
  
        <div class="row" style="margin-top: 20px;
        color: #919191;
        overflow-wrap: break-word; padding-left: 30px;">
          <div class="col-md-3" style="display: flex;
          justify-content: space-evenly;">
            <div class="check" style="display: flex;
            flex-direction: column;
            align-items: center;">
              <span class="text-label" style="margin-bottom: 10px;">{{'pendingAppointments.new'| translate}}</span>
              <app-onofswitch [switchInput]='employeeForm.value.newSales'
                (switchChange)="updateSwitchValues($event, 'newSales')"></app-onofswitch>
            </div>
            <div class="check" style="display: flex;
            flex-direction: column;
            align-items: center; padding-left: 10px;">
              <span class="text-label" style="margin-bottom: 10px;">{{'pendingAppointments.used'| translate}} </span>
              <app-onofswitch [switchInput]='employeeForm.value.usedSales'
                (switchChange)="updateSwitchValues($event, 'usedSales')"></app-onofswitch>
            </div>
          </div>
          <div class="col-md-6" style="display: flex;
          justify-content: space-evenly;">
            <div class="check" style="display: flex;
            flex-direction: column;
            align-items: center;">
              <span class="text-label" style="margin-bottom: 10px;">{{'serviceSchedule.testdrive'| translate}} </span>
              <app-onofswitch [switchInput]='employeeForm.value.testdrive'
                (switchChange)="updateSwitchValues($event, 'testdrive')"></app-onofswitch>
            </div>
            <div class="check" style="display: flex;
            flex-direction: column;
            align-items: center;">
              <span class="text-label" style="margin-bottom: 10px;">{{'serviceSchedule.delivery'| translate}}</span>
              <app-onofswitch [switchInput]='employeeForm.value.delivery'
                (switchChange)="updateSwitchValues($event, 'delivery')"></app-onofswitch>
            </div>
            <div class="check" style="display: flex;
            flex-direction: column;
            align-items: center;">
              <span class="text-label" style="margin-bottom: 10px;">{{'serviceSchedule.learning'| translate}}</span>
              <app-onofswitch [switchInput]='employeeForm.value.learning'
                (switchChange)="updateSwitchValues($event, 'learning')"></app-onofswitch>
            </div>
          </div>
          <div class="col-md-3" style="display: flex;
          justify-content: space-evenly;">
            <div class="check" style="display: flex;
            flex-direction: column;
              align-items: center; padding-right: 3rem;">
              <span class="text-label" style="margin-bottom: 10px;">F&I</span>
              <app-onofswitch [switchInput]='employeeForm.value.finance'
                (switchChange)="updateSwitchValues($event, 'finance')"></app-onofswitch>
            </div>
          </div>
        </div>
      </div>

      <div class="row employee-data">
        <div class="col-md-6">

          <ng-container *ngIf="(employee$ | async)?.jobCode === 'ADVISOR'">
            <div class="row">
              <mat-label>{{'servicePersonnel.displayName'| translate}}</mat-label>
            </div>
            <div class="row">
              <mat-form-field appearance="outline">
                <input matInput formControlName='displayName'>
                <mat-error>{{'servicePersonnel.pleaseEnterDisplayName'| translate}}</mat-error>
              </mat-form-field>
            </div>
          </ng-container>

          <div class="row">
            <mat-label>{{'servicePersonnel.phoneNumber'| translate}}</mat-label>
          </div>
          <div class="row">
            <mat-form-field appearance="outline" class='contact-number'>
              <input matInput type="text" placeholder=""
      formControlName="phone" appPhoneFormat inputMode="numeric"
      [errorStateMatcher]="matcher"/>
        <mat-error>{{'servicePersonnel.pleaseEnterValidPhoneNumber'| translate}}</mat-error>
            </mat-form-field>
          </div>

          <ng-container *ngIf="(employee$ | async)?.jobCode === 'TECHNICIAN'">
            <div class="row">
              <mat-label>{{'servicePersonnel.flatRateHoursObjective'| translate}}</mat-label>
            </div>
            <div class="row">
              <mat-form-field appearance="outline">
                <input type="number" matInput formControlName='flatRateHours'>
                <mat-error>{{'servicePersonnel.pleaseEnterValidFlatRateHoursObjective'| translate}}</mat-error>
              </mat-form-field>
            </div>
          </ng-container>
        </div>
        <div class="col-md-6">
          <div class="row">
            <mat-label>{{'servicePersonnel.emailAddress'| translate}}</mat-label>
          </div>
          <div class="row">
            <mat-form-field appearance="outline">
              <input matInput formControlName='email'>
              <mat-error>{{'generalSettings.pleaseEnterValidEmail'| translate}}</mat-error>
            </mat-form-field>
          </div>

          <ng-container *ngIf="(employee$ | async)?.jobCode === 'ADVISOR'">
            <div class="row">
              <mat-label>{{'servicePersonnel.languages'| translate}}</mat-label>
            </div>
            <div class="row">
              <mat-form-field appearance="outline">
                <mat-select formControlName='languages' multiple [compareWith]="languageCompareWith">
                  <mat-option *ngFor="let language of languages" [value]='language'>
                    {{ getTranslation(language.language) | translate }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="employeeForm.controls.languages.errors?.required">
                  {{'generalSettings.pleaseSelectLanguagesSpoken'| translate}}</mat-error>
              </mat-form-field>
            </div>
          </ng-container>

        </div>
      </div>
      <div class="alert">
        <asp-icon name="ic-20-feedback-alert-error.svg" width="1rem" *ngIf="clickedOutside"></asp-icon>
        <h6 *ngIf="clickedOutside">{{'servicePersonnel.alertMessage'| translate}}</h6>
      </div>
      <div class="actions" [ngClass]="clickedOutside ? 'btm-45' : ''" >
        <div class="form-action">
          <button class="clear" type="button" (click)="clear()"> {{'servicePersonnel.clear'| translate}} </button>
        </div>
        <div class="form-action">
          <button class="save" type="button" [disabled]="!employeeForm.valid" (click)="save()">{{'overrideCapacity.save'| translate}}</button>
        </div>
      </div>
    </form>
  </div>
</div>